export const _32bitIntMaxValue = 2147483647;